import axios from '@/axios.js'

export default {
  changeVat({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post("/expense/decreaseorincreasevat", obj)
        .then((response) => {
          console.log("2")
          console.log(response.data)
          commit('SET_EXPENSEPRODUCTSS', response.data.expenselines)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItemExpense ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.post("/expense/deleteproductinexpense/", obj)
        .then((response) => {
          commit('REMOVE_EXPENSEPRODUCT', response.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateExpenseProduct ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/expense/updateproductinexpense', item)
        .then((response) => {
          //location.reload();
          commit('UPDATE_EXPENSEPRODUCT', response.data.expenselines[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createExpenseProduct ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/expense/createproductinexpense', item)
        .then((response) => {
          //location.reload();
          commit('CREATE_EXPENSEPRODUCT', response.data.expenselines[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpenseProducts ({ commit },id){
    return new Promise((resolve, reject) => {
      axios.get("/getexpenseproducts/"+id)
        .then((response) => {
          console.log("1")
          console.log(response.data)
          commit('SET_EXPENSEPRODUCTS', response.data.expenselines)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpensesDashboard ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/extractreportexpenses/2024')
        .then((response) => {
          commit('SET_EXPENSESDASHBOARD', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpenses ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/expenses/data')
        .then((response) => {
          commit('SET_EXPENSES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchExpense ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/expense/data/${userId}`)
        .then((response) => {
          console.log(response.data)
          commit('SET_EXPENSE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAddressDelivery({commit}, idoperation)
  {
    return new Promise((resolve, reject) => {
      axios.get(`/person/getaddressdeliverydetails/${idoperation}/${idoperation}`)
        .then((response) => {
          commit('SET_ADDRESSDELIVERY', response.data[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchAddressBilling({commit}, idoperation)
  {
    return new Promise((resolve, reject) => {
      axios.get(`/person/getaddressbillingdetails/${idoperation}/${idoperation}`)
        .then((response) => {
          commit('SET_ADDRESSBILLING', response.data[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchProductListPdf({commit}, userId,languageId)
  {
    return new Promise((resolve, reject) => {
      axios.get(`/getproductlistpdf/${userId}/${languageId}`)
        .then((response) => {
          commit('SET_PRODUCTLISTPDF', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchInvoiceLinked ({ commit }, userId) { // OK
    return new Promise((resolve, reject) => {
      axios.get(`/getoperationsettotransporttable/${userId}`)
        .then((response) => {
          commit('SET_INVOICEATTACHED', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  findSumalNeedForATransport ({ commit }, userId) { // OK
    return new Promise((resolve, reject) => {
      axios.get(`/getsumalneedforatransport/${userId}`)
        .then((response) => {
          //commit('SET_SUMAL_NEED_FOR_A_TRANSPORT', response.data.count)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  linkOperationToTransportFromAdd ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/settransporttooperations', item)
        .then((response) => {
          console.log(item)
          commit('CREATE_INVOICEATTACHED', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  linkOperationToTransport ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/settransporttooperations', item)
        .then((response) => {
          console.log(item)
          commit('UPDATE_INVOICEATTACHED', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  UnlinkOperationToTransport ({ commit }, item) { // OK
    return new Promise((resolve, reject) => {
      axios.post('/settransporttooperations', item)
        .then((response) => {
          commit('REMOVE_INVOICEATTACHED', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getPeopleList ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/people_name/data')
        .then((response) => {
          commit('SET_PEOPLE_LIST', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchm3difference ({ commit }, operationId) {
    return new Promise((resolve, reject) => {
      axios.get(`/operation-production/getinoutdifference/${operationId}`)
        .then((response) => {
          commit('SET_M3DIFFERENCE', response.data.volume)
          resolve(response.data.volume)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetcheurdifference ({ commit }, operationId) {
    return new Promise((resolve, reject) => {
      axios.get(`/operation-production/getinoutdifferenceeur/${operationId}`)
        .then((response) => {
          commit('SET_EURDIFFERENCE', response.data.price)
          resolve(response.data.price)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchrondifference ({ commit }, operationId) {
    return new Promise((resolve, reject) => {
      axios.get(`/operation-production/getinoutdifferenceron/${operationId}`)
        .then((response) => {
          commit('SET_RONDIFFERENCE', response.data.price)
          resolve(response.data.price)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchOperations ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/operation/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchTransports ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/transportv2/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchReceptions ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/reception/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchSales ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/saleactiveinactivefscexport/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchSalesBroker ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/saleactiveinactive/data/'+localStorage.getItem('login-broker'))
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchProductions ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/productionnew/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchInventories ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/inventory/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOperationProductsInventory ({ commit },obj){
    return new Promise((resolve, reject) => {
      axios.get(`/getinventorylist/`+obj.idproductcategory+"/"+obj.idoperation+"/"+obj.date)
        .then((response) => {
          commit('SET_OPERATIONPRODUCTS', response.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchOperation ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/operation/data/${userId}`)
        .then((response) => {
          commit('SET_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  // Catégorie budget + payé d'une dépense / facture fournisseur (route dédiée,
  // seule écriture ouverte à la comptable).
  classifyExpense (_, { id, budgetcategory, isexppaid }) {
    return axios.post(`/expense/${id}/classify`, { budgetcategory, isexppaid })
  },
  updateOperation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operation/update', item)
        .then((response) => {
          //commit('UPDATE_USERS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createOperation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operation/create', item)
        .then((response) => {
          commit('CREATE_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createTransport ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/transport/create', item)
        .then((response) => {
          commit('CREATE_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOperationProducts ({ commit },idoperation) {
    return new Promise((resolve, reject) => {
      axios.get(`/operations_products/data/`+idoperation)
        .then((response) => {
          commit('SET_OPERATIONPRODUCTS', response.data.products)
          resolve(response.data.products)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/update', item)
        .then((response) => {
          //location.reload();
          commit('UPDATE_OPERATIONPRODUCTS', response.data.data.products[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateTransportCost ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/update', item)
        .then((response) => {
          //location.reload();
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/create', item)
        .then((response) => {
          commit('CREATE_OPERATIONS_PRODUCTS', Object.assign(response.data.data.products[0]))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get("/operations_products/product/delete/" + obj.idproduct + "/" + obj.idoperation + "?who=" + encodeURIComponent(obj.who || ""))
        .then((response) => {
          commit('REMOVE_OPERATIONPRODUCTS', obj.idproduct)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
